var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"title",rawName:"v-title"}],staticClass:"wallet",attrs:{"data-title":"钱包详情"}},[_c('header'),_c('section',[_c('router-view')],1),_c('footer',[_c('walletTabar')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }